import { UserModule } from '@/store/user';
import axios from 'axios';

/* eslint-disable */
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 5000,
  // withCredentials: true // send cookies when cross-domain requests
});

//  HTTP 2xx(200~299) 응답을 모두 성공으로 간주
//    - 200 OK : 일반 요청 성공
//    - 201 Created : 새 자원 생성 성공
//    - 204 No Content : 본문 없는 요청 성공 (DELETE 등)
//    - 그 외 2xx 응답들도 정상 처리
// Response interceptors
service.interceptors.response.use(
  (response: any) => {
    const res = response.data;
//     if (response.status !== 200) {

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return response;
  },
  (error: any) => {
    const res = error.response;
    if (res.status === 401 && res.data.error === 'invalid_token') {
      UserModule.LogOut();
      window.location.replace('/');
      return;
    }
    // alert(res.data.message || '사용자 요청을 실패했습니다.');
    return Promise.reject(error);
  },
);

export default service;
